/** Private groups — join limits (must match functions/group_constants.py). */
export const MAX_FREE_GROUP_MEMBERSHIPS = 2;

export const GROUP_PLUS_CREATE_MESSAGE =
  'LockedIn Plus is required to create a private league.';

export const GROUP_FREE_JOIN_LIMIT_MESSAGE =
  `Free accounts can join up to ${MAX_FREE_GROUP_MEMBERSHIPS} leagues. Plus unlocks unlimited leagues.`;

export const GROUP_LEAGUE_CARD_HEADLINE = 'Start a League';

export const GROUP_LEAGUE_CARD_BADGE = 'Plus feature';

export const GROUP_LEAGUE_CARD_SUBLINE =
  'Run a private league for your crew — included with LockedIn Plus.';

export const GROUP_LEAGUE_CARD_SUBLINE_FREE =
  'Join leagues you\'re invited to, or upgrade to start your own.';

export const GROUP_LEAGUE_CARD_SUBLINE_PLUS =
  'Invite friends, post group locks, and track the leaderboard together.';

export const GROUP_PLUS_LEAGUE_UPSELL =
  'Create a private league for your crew — included with LockedIn Plus.';

export const GROUP_MY_GROUPS_LABEL = 'My Groups';

export const GROUP_PLUS_UPSELL_HEADLINE = 'LockedIn Plus — leagues';

export const GROUP_PLUS_UPSELL_SUBLINE =
  '7-day free trial. Subscription unlocks league features — it does not add wallet funds.';

export const GROUP_PLAN_MATRIX = [
  { feature: 'Join leagues', free: `Up to ${MAX_FREE_GROUP_MEMBERSHIPS}`, plus: 'Unlimited' },
  { feature: 'View activity & leaderboard', free: true, plus: true },
  { feature: 'Invite friends', free: true, plus: true },
  { feature: 'Create a league', free: false, plus: true },
  { feature: 'Post group locks', free: false, plus: true },
  { feature: 'Accept group locks', free: false, plus: true },
  { feature: 'Platform fee on wins', free: '5%', plus: '2%' },
];

export const GROUP_UPSELL_VARIANTS = {
  create_group: {
    title: 'Start a league with Plus',
    body: 'Create a private league for your crew, invite friends, and run group locks together.',
    bullets: [
      'Create unlimited private leagues',
      'Post and accept group locks',
      '2% platform fee on challenge wins',
    ],
  },
  join_cap: {
    title: 'Unlimited leagues with Plus',
    body: 'You\'ve joined the maximum number of leagues on a free account. Upgrade to join every league you\'re invited to.',
    bullets: [
      'Join unlimited leagues',
      'Create your own leagues',
      'Post and accept group locks',
    ],
  },
  group_lock_post: {
    title: 'Post group locks with Plus',
    body: 'Group locks are a Plus feature — challenge your league members with private open locks.',
    bullets: [
      'Post locks inside your league',
      'Accept locks from crew members',
      'Compete on the weekly leaderboard',
    ],
  },
  group_lock_accept: {
    title: 'Accept group locks with Plus',
    body: 'Join the action in your league — Plus unlocks posting and accepting group locks.',
    bullets: [
      'Accept locks from league members',
      'Post your own group locks',
      'Track wins on the leaderboard',
    ],
  },
  create_league_card: {
    title: 'Start a league with Plus',
    body: 'Private leagues keep your crew\'s locks, activity, and leaderboard in one place.',
    bullets: [
      'Create and own your league',
      'Invite friends by arena name',
      'Run group locks with your roster',
    ],
  },
  lockbox_league_hero: {
    title: 'Start your first league',
    body: 'Create a private league for your crew, send an invite link, and compete on the season leaderboard.',
    bullets: [
      'Create your first private league',
      'Invite friends with a shareable link',
      'Track wins together all season',
    ],
  },
  groups_page: {
    title: 'Create leagues with Plus',
    body: 'Free accounts can join leagues and view activity. Plus unlocks creating and running your own.',
    bullets: [
      'Create private leagues',
      'Unlimited league memberships',
      'Full group lock access',
    ],
  },
};
